import React from 'react';
import { Card, InputNumber, Col, Tag, Row, Tooltip } from 'antd';
import { ShoppingCartOutlined } from '@ant-design/icons';
import eshopData from '../enums/data.json'
const { Meta } = Card;

const createCard = (data, addCallback) => {
  return (
    <Col key={data.id} xs={24} md={12} lg={12} xl={8} xxl={8}>


      <Card
        // style={{ height: 300 }}
        cover={
          <div>
            {data.isNew ? <Tag color="#f50">Novinka!</Tag> : null}
            {data.isXmas ? <Tag color="#4cc779">Vánoční speciál!</Tag> : null}
            <img
              alt={data.label}
              src={process.env.PUBLIC_URL + `/resized_images/${data.id}.jpg`}
              // src={data.image}
              style={{ maxHeight: "200px", width: 'auto', display: 'block', margin: '0 auto', paddingTop: 5 }}
            />
          </div>
        }
      >

        <Meta
          title={<Tooltip title={data.label}>{data.label}</Tooltip>}
          style={{
            marginBottom: 10,
            wordBreak: 'break-word', // Ensures words break only where appropriate
            overflowWrap: 'break-word', // Ensures long words fit within the container
          }}
        />
        <div style={{ minHeight: 150 }}>
          <div style={{ textAlign: 'left', marginBottom: 10 }}>
            <span>{data.descr}</span>
          </div>
          <div style={{ textAlign: 'center', marginBottom: 10 }}>
            <span>{data.minidescr}</span>
          </div>
          <div style={{ textAlign: 'center' }}>
            <InputNumber size="small" min={0} max={eshopData.rules.maxOrderItems} defaultValue={0} onChange={(el) => addCallback(data.id, el, data)} />
            <ShoppingCartOutlined style={{ marginLeft: 10, marginRight: 5 }} />
            <span>{data.price} Kč</span>
          </div>

        </div>
      </Card>
    </Col>
  )
}


export default function Items(props) {

  return (
    <Row gutter={[8, 8]}>
      {props.items.sort((a, b) => b.isNew - a.isNew).map(el => createCard(el, props.addItem))}
    </Row>


  )
}
